// 使用 public/lib/g6.min.js 通过 <script> 注入到 window.G6 的全局变量
// 避免 webpack 4 编译 @antv/g6@5 源码（含 class fields / import.meta.url 等现代语法）失败
const { Graph } = (typeof window !== 'undefined' && window.G6) ? window.G6 : {}

// 节点颜色（按难度等级）
const nodeFill = {
  0: '#F4A12D',
  1: '#F4A12D',
  2: '#38A4EA',
  3: '#38A4EA',
  4: '#38A4EA',
}

// 线条配置（按关系类型）
export const edgesOps = {
  0: {
    labelText: '前后置关系',
    stroke: '#3fdf9c',
    endArrow: true,
    lineDash: [5, 5],
  },
  1: {
    labelText: '关联关系',
    stroke: '#FFA07A',
    lineDash: [5, 5],
    endArrow: false,
  },
  2: {
    labelText: '父子关系',
    stroke: '#a5b3e4',
    endArrow: true,
  },
  3: {
    labelText: '',
    stroke: '#3fdf9c',
    lineDash: [0, 0],
    endArrow: true,
  },
}

// 超边配置
const clusterOps = {
  0: '#833fdf', // 普通超边
  1: '#dfc43f', // 资源超边
  2: '#df3f40', // 任务超边
}

// 难度等级
export const difficultyList = [
  { text: '基础', color: '#3aa0c2' },
  { text: '容易', color: '#9EE6B7' },
  { text: '中等', color: '#FFE569' },
  { text: '较难', color: '#FFB25B' },
  { text: '难题', color: '#E74646' },
]

const completedState = [
  { text: '未完成', color: '#E74646' },
  { text: '已完成', color: '#9EE6B7' },
]

// 默认交互行为
export const defaultBehaviors = [
  'zoom-canvas',
  'drag-element',
  'drag-canvas',
  {
    type: 'hover-activate',
    degree: 1,
    state: 'highlight',
    inactiveState: 'dim',
    onHover: function (event) {
      event.view.setCursor('pointer')
    },
    onHoverEnd: function (event) {
      event.view.setCursor('default')
    },
  },
]

// 初始化G6图谱（始终传入空数据，实际数据通过 setData 设置）
export var initGraph = function () {
  var container = document.getElementById('kg-container')
  var width = container.scrollWidth || 500
  var height = container.scrollHeight || 500
  var graph = new Graph({
    container: container,
    width: width,
    height: height,
    data: {
      nodes: [],
      edges: [],
    },
    animation: false,
    node: {
      palette: { field: 'cluster' },
      state: {
        selected: {
          fill: '#FF4D4F',
          lineWidth: 0,
        },
        highlight: {
          lineWidth: 0,
          opacity: 1,
        },
        dim: {
          opacity: 0.1,
        },
      },
      style: {
        opacity: 1,
        labelText: function (d) { return d.labelText },
        badges: function (d) { return d.badges },
        fontSize: 10,
        padding: [2, 6],
        backgroundRadius: 8,
      },
    },
    edge: {
      style: {
        lineWidth: 1,
        opacity: 1,
      },
      state: {
        highlight: { opacity: 1 },
        dim: { opacity: 0.1 },
      },
    },
    layout: {
      type: 'force',
      preventOverlap: true,
      nodeSize: 100,
      nodeSpacing: 120,
      unitRadius: 420,
      linkDistance: 420,
    },
    plugins: [],
    behaviors: defaultBehaviors,
    autoFit: 'center',
  })
  return graph
}

var createStyle = function (baseColor) {
  return {
    fill: baseColor,
    stroke: baseColor,
    labelFill: baseColor,
    labelPadding: 2,
    labelBackgroundRadius: 1,
  }
}

// 处理超边
export var formatCluster = function (data) {
  var clustersList = []
  if (data && data.length) {
    data.forEach(function (item) {
      if (item.knowledgeList && item.knowledgeList.length) {
        var members = item.knowledgeList.map(function (k) { return String(k.id) })
        clustersList.push({
          key: item.id,
          type: 'bubble-sets',
          members: members,
          labelText: item.name,
          ...createStyle(clusterOps[item.hyperedgeType]),
        })
      }
    })
  }
  return clustersList
}

// 处理节点
export var formatNodes = function (data, stateType) {
  stateType = stateType || ''
  var nodes = []
  if (data && data.length) {
    data.forEach(function (item) {
      // 兼容 level 和 difficultyLevel 两种字段
      var level = item.level !== undefined ? item.level : (item.difficultyLevel !== undefined ? item.difficultyLevel : 2)
      // 所有知识点统一大小
      var nodeSize = 40
      var node = {
        data: item,
        id: String(item.id),
        labelText: item.name,
        level: level,
        style: {
          size: nodeSize,
          fill: nodeFill[level] || '#38A4EA',
        },
        stateType: stateType,
        dataType: 'node',
      }
      switch (stateType) {
        case 'completed':
          node.states = [item.completed ? '' : 'disabled']
          break
        default:
          node.states = []
          break
      }
      nodes.push(node)
    })
  }
  return nodes
}

// 处理边
export var formatEdges = function (data) {
  var edges = []
  if (data && data.length) {
    data.forEach(function (item) {
      var sourceId = null
      var targetId = null

      if (item.sourceKnowledge && item.targetKnowledge) {
        sourceId = item.sourceKnowledge.id
        targetId = item.targetKnowledge.id
      } else if (item.sourceKnowledgeId && item.targetKnowledgeId) {
        sourceId = item.sourceKnowledgeId
        targetId = item.targetKnowledgeId
        if (!item.sourceKnowledge) {
          item.sourceKnowledge = { id: item.sourceKnowledgeId, name: item.sourceKnowledgeName || '' }
        }
        if (!item.targetKnowledge) {
          item.targetKnowledge = { id: item.targetKnowledgeId, name: item.targetKnowledgeName || '' }
        }
      }

      if (sourceId != null && targetId != null) {
        var ops = edgesOps[item.relationType] || edgesOps[0]
        // 只提取 G6 可识别的样式属性，排除 labelText 等业务字段
        var edgeStyle = {
          stroke: ops.stroke,
        }
        if (ops.lineDash) {
          edgeStyle.lineDash = ops.lineDash
        }
        if (ops.endArrow) {
          edgeStyle.endArrow = true
          edgeStyle.endArrowFill = ops.stroke
          edgeStyle.endArrowStroke = ops.stroke
        }
        edges.push({
          id: String(item.id),
          data: item,
          source: String(sourceId),
          target: String(targetId),
          linkDistance: 200,
          type: 'quadratic',
          dataType: 'edge',
          style: edgeStyle,
        })
      } else {
        console.warn('[G6] 跳过无效边:', item.id, item)
      }
    })
  }
  return edges
}

// 处理学习路径的关系
export var formatPathEdges = function (data) {
  var result = []
  for (var i = 0; i < data.length - 1; i++) {
    result.push({
      id: 'path_edge_' + i,
      relationType: 3,
      sourceKnowledge: data[i],
      targetKnowledge: data[i + 1],
    })
  }
  return result
}

/**
 * 右键菜单插件
 * @param {String} type - chapter/path
 * @param {Object} graph - G6 graph instance
 * @param {Function} menuFun - 回调函数
 * @param {Boolean} showMenu - 是否显示菜单
 */
export var pluginContextmenu = function (type, graph, menuFun, showMenu) {
  if (showMenu === undefined) showMenu = true
  return {
    type: 'contextmenu',
    trigger: 'contextmenu',
    onClick: function (value, target, current) {
      var data = {}
      if (current && current.type == 'node') {
        data = graph.getNodeData(current.id)
      }
      if (current && current.type == 'edge') {
        data = graph.getEdgeData(current.id)
      }
      menuFun(value, data.data)
    },
    getItems: function (e) {
      var items = []
      if (showMenu) {
        switch (type) {
          case 'chapter':
            switch (e.target.type) {
              case 'node':
                items = [
                  { name: '编辑知识点', value: 'editNode' },
                  { name: '添加知识点关系', value: 'addEdge' },
                  { name: '删除知识点', value: 'delNode' },
                ]
                break
              case 'edge':
                items = [
                  { name: '编辑知识点关系', value: 'editEdge' },
                  { name: '删除知识点关系', value: 'delEdge' },
                ]
                break
            }
            break
          case 'path':
            switch (e.target.type) {
              case 'node':
                items = [
                  { name: '编辑排序', value: 'editPathNode' },
                  { name: '移除路径', value: 'delPathNode' },
                ]
                break
            }
            break
        }
      }
      return items
    },
  }
}

// Tooltip 插件
export var pluginTooltip = function (type) {
  return {
    type: 'tooltip',
    getContent: function (e, items) {
      var result = ''
      items.forEach(function (item) {
        var dataType = item.dataType
        var difficultyLevel = (item.data && (item.data.difficultyLevel || item.data.difficulty_level)) || 0
        var chapterName = item.data && (item.data.chapterName || item.data.chapter_name)
        switch (dataType) {
          case 'node':
            var diff = difficultyList[difficultyLevel] || difficultyList[0]
            var tagStyle = 'padding: 2px 5px; border-radius: 4px;color: ' + diff.color + '; border: 1px solid ' + diff.color
            result += '<p>知识点: ' + item.data.name + '</p><p>所属节: ' + (chapterName || '-') + '</p><p>知识点难易度: <span style="' + tagStyle + '">' + diff.text + '</span></p>'
            if (item.stateType == 'completed' && item.data.completed !== undefined) {
              var cs = completedState[item.data.completed] || completedState[0]
              var stateStyle = 'padding: 2px 5px; border-radius: 4px;color: ' + cs.color + '; border: 1px solid ' + cs.color
              result += '<p>完成情况: <span style="' + stateStyle + '">' + cs.text + '</span></p>'
            }
            break
          case 'edge':
            if (type != 'path' && item.data && item.data.sourceKnowledge && item.data.targetKnowledge) {
              result += '<p>关系类型: ' + edgesOps[item.data.relationType].labelText + '</p><p>起始知识点: ' + item.data.sourceKnowledge.name + '</p><p>结束知识点: ' + item.data.targetKnowledge.name + '</p>'
            }
            break
        }
      })
      return result
    },
  }
}
